// NOTE: Dependencies: jQuery, Moment.js 20230404
(function ($, Drupal, drupalSettings) {
	$.fn.lmLiveEvents = function(options) {
		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		//drupalSettings

		// Default settings are set here.
		var settings = $.extend({
			count: 10,
			refreshinterval: 5000,
			mobileBreakpoint: 981,
			errortext: 'There is currently no race data for this event.',
			loadingclass: 'table--loading',
			driverfeed: '/driver-profile/',
			apiurl: 'https://nhralaravel.nhradata.com/api/public/events',
			updateClass: 'table__row-updated',
			errorClass: 'table--responsive',
			token: $(window)[0].drupalSettings.events.eventToken,
			$window: $(window)
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		var liveEventsCollection = [], // Race Data Array.
			driverCollection = [], // Driver Data Array.
			raceMarkUp = '', // Store the mark-up and the table is being built.
			titleArea = '', // Store the title part of the mark-up.
			leftWin = '', // Is the left driver the winner?
			rightWin = '', // Is the right driver the winner?
			leftET = '', // ET for left driver
			rightET = '', // ET for rightET driver
			originalMarkUp = '', // Store the original mark-up of the table including the caption tag.
			spacer = '', // Store mark-up for the spacer row.
			matches = 0, // Record the number of matches between the current data nad updated data (will be 0 or 1).
			updatedDate = false, // Store the last date and time the data was updated successfully.
			lastUpdatedDate = '', // Store the lastupdated param text.
			lastRaceID = false, // Store the ID of the oldest race in the data.
			lastrace = '', // Store the lastrace param text.
			url = '',  // Used to construct api url
			firstLoad = false,  // Store the generated API Url.
			liveEventsCollectionUpdateOrder = [], // Used to get the updated date
			reRendering = false; // Indicate that the Layout is being Re-Rendered (on resize/rotate).

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
			settings = $context.data();

			var driverRequest = $.ajax({
				url: settings.driverfeed,
				method: "GET",
				dataType: "json",
				headers: {
					'Content-Type': 'application/json',
					'Access-Control-Allow-Origin': 'https://nhra.com',
					'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers'
				}
			});

			driverRequest.done(function( data ) {
				// Set the driver data
				driverCollection = data;

				// Now the driver info has been loaded, start the process.
				methods.autoRefresh($context);

			});

			driverRequest.fail(function( jqXHR, message ) {
				// If no items have previously been loaded, show the no results message.
				liveEventsCollection = "error";
				// Render the updated Table.
				methods.autoRefresh($context);
			});
		}

		// Load the Data.
		methods.loadData = function($context) {
			// Work out lastupdated param.
			lastUpdatedDate = updatedDate ? `&lastupdated=${updatedDate}` : '';
			lastrace = lastRaceID ? `&lastrace=${lastRaceID}` : '';
			let etToken = `${settings.token};`
			let eTokenQs = etToken ? `&eToken=${etToken}` : '';

			let host = document.location.hostname;
			var raceRequest = $.ajax({
				url: `${settings.apiurl}?count=${settings.count}${lastUpdatedDate}${lastrace}${eTokenQs}`,
				method: "GET",
				dataType: "json",
				headers: {
					'Content-Type': 'application/json',
					"Access-Control-Allow-Methods": "GET, OPTIONS",
					'Access-Control-Allow-Origin': 'https://nhra.com',
					'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Access-Control-Allow-Origin, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Methods, Access-Control-Request-Headers',
					'X-Et': `${etToken}`,
				}
			});

			raceRequest.done(function( data ) {
				// Only update the collection and paint the page if we recieve data from the server.
				if(data.length > 0) {

					if (typeof liveEventsCollection !== 'undefined' && liveEventsCollection.length > 0 && liveEventsCollection != 'error') {

						// Loop through the new data looking for updates and new items.
						data.forEach(function(chunk, chunkIndex) {

							chunk.forEach(function (newItem, newIndex, newArray) {

								// Set a counter to check if there are any matches later in the process.
								matches = 0;

								// Loop through the previous data checking for items to update.
								liveEventsCollection.forEach(function (collection) {

									collection.forEach(function (item, index, array) {

										// On the first new item, use the existing loop to remove any previous update classes
										if(chunkIndex == 0 && newIndex == 0) {
											collection[index].highlight = '';
										}

										// If the race exists, update it's data.
										if (newItem.RaceId === item.RaceId) {
											// Update item data.
											collection[index] = newItem;
											// Set a new attribute used in highlighting updated items.
											collection[index].highlight = settings.updateClass;
											// Increment counter.
											matches++;
										}
									});
								});

								if(matches === 0) {

									// Set a new attribute used in highlighting updated items.
									newItem.highlight = settings.updateClass;
									// Add new item to the top.
									liveEventsCollection.unshift(chunk);
								}
							});
						});

					} else {
						// load all of the data on first load.
						liveEventsCollection = data;

						// Set a new attribute used in highlighting updated items.
						liveEventsCollection.forEach(function (chunk) {
							chunk.forEach(function (item, index, array) {
								chunk[index].highlight = '';
							});
						});
					}

					if (liveEventsCollection.length > 0) {

						// Sort the data by Race time
						liveEventsCollection.sort(methods.compareRaceTime);

						// Set the ID of the oldest race in the data (ON SCREEN).
						var lastRace = liveEventsCollection[liveEventsCollection.length -1];

						if(lastRace.length > 0) {
							lastRaceID = lastRace[lastRace.length - 1].RaceId;
						}

						// If there are more than the max count of races, remove the older races.
						if (liveEventsCollection.length > settings.count) {
							liveEventsCollection = liveEventsCollection.slice(0, settings.count);
						}

						// Loop through the results of the cut down data.
						liveEventsCollection.forEach(function (chunk) {
							// If the driver link of either left or right has not been processed, then.

							chunk.forEach(function (item, index, array) {
								if(!item.driverRightUrl || !item.driverLeftUrl) {
									// Loop through the driver information matching again race drivers.
									driverCollection.forEach(function (driver, driverIndex, driverArray) {
										// If the right driver matches the current driver add their link.
										if (item.rightId === driver.account || item.rightName === driver.name) {
											chunk[index].driverRightUrl = `<a href="${driver.url}" class="table__link" target="_blank">${item.rightName}</a>`;
										}
										// If the left driver matches the current driver add their link.
										if (item.leftID === driver.account || item.leftName === driver.name) {
											chunk[index].driverLeftUrl = `<a href="${driver.url}" class="table__link" target="_blank">${item.leftName}</a>`;
										}
									});
								}

								// If the right driver doesn't have a profile page, just show his name.
								if(!array[index].driverRightUrl) {
									chunk[index].driverRightUrl = `${item.rightName}`;
								}
								// If the left driver doesn't have a profile page, just show his name.
								if(!array[index].driverLeftUrl) {
									chunk[index].driverLeftUrl = `${item.leftName}`;
								}
							});
						});

						if (data.length > 0) {
							// liveEventsCollectionUpdateOrder = data;
							liveEventsCollectionUpdateOrder = [];
							liveEventsCollectionUpdateOrder = liveEventsCollectionUpdateOrder.concat(liveEventsCollection);

							// Sort alternative data by updateDate
							liveEventsCollectionUpdateOrder.sort(methods.compareUpdateDate);

							// Set the latest update date to be used in the next request.
							var lastRace = liveEventsCollectionUpdateOrder[liveEventsCollectionUpdateOrder.length - 1];

							if(lastRace.length > 0) {
								updatedDate = lastRace[lastRace.length - 1].UpdatedDate;
							}
						}
					}

					// Render the updated table.
					if(settings.$window[0].innerWidth > settings.mobileBreakpoint) {
						$context.addClass('loaded--desktop');
						methods.render($context);
					} else {
						$context.addClass('loaded--mobile');
						methods.renderMobile($context);
					}
				} else {
					if ($context.hasClass(settings.loadingclass && !reRendering)) {
						liveEventsCollection = "error";
						// Render the updated Table.
						if(settings.$window[0].innerWidth > settings.mobileBreakpoint) {
							methods.render($context);
						} else {
							methods.renderMobile($context);
						}
					}
				}
			});

			raceRequest.fail(function( jqXHR, message ) {
				// If no items have previously been loaded, show the no results message.
				if(liveEventsCollection.length < 1) {
					liveEventsCollection = "error";
					// Render the updated Table.
					if(settings.$window[0].innerWidth > settings.mobileBreakpoint) {
						methods.render($context);
					} else {
						methods.renderMobile($context);
					}
				}
			});
		}

		// Bind events
		methods.render = function($context) {
			// If this is the first load, get the caption mark.
			raceMarkUp = originalMarkUp;

			// Check category of each item
			var category;

			// IF: there is an error loading the data.
			if (liveEventsCollection == "error" || liveEventsCollection.length < 1) {
				$context.addClass(settings.errorClass);
				raceMarkUp += `<tr class="table__row-spacer"><td colspan="16">${settings.errortext}</td></tr>`;

			// ELSE: - render items
			} else {
				$context.removeClass(settings.errorClass);
				liveEventsCollection.forEach(function (chunk, chunkIndex) {

					var rowHeader = '';
					var rowBody = '';
					var extra = '';
					var lanePosition = 1;
					var chunkSize = chunk.length;
					var isMultiLane = chunkSize > 1;

					// Spaces out each race
					var spacer = chunkIndex === 0 ? '' : '<tr class="table__row-spacer"><td colspan="14"></td></tr>';
					var isLast = ((chunkIndex + 1) == liveEventsCollection.length ? "last-row" : "");

					chunk.forEach(function (item, index, array) {

						// 2 (header grp + round) + Size of the Group * 2 (2 per group) to get total rowspaw
						var rowSpanSize = 2 + ((chunk.length * 2));
						var rowSpanNoHeaderSize = rowSpanSize - 1;

						// Left/Right Lane Default Text
						var leftLane = "Left";
						var rightLane = "Right";

						// Result Ranks
						var leftWinStatus = null;
						var rightWinStatus = null;
						var leftWinClass = "";
						var rightWinClass = "";

						// If round name starts w/ q (Qualifying round), ignore (per spec).
						// Set the ranking of the drivers.
						var rndType = (typeof item != 'undefined') ? (typeof item.rnd != 'undefined')? item.rnd.charAt(0).toLowerCase() : '' : '';
						//if ('q' !== item.rnd.charAt(0).toLowerCase() ) {
						if ('q' !== rndType ) {
							leftWinStatus = item.leftWin === "W" ? "WIN" : item.leftWin === "R" ? "RU" :  $.isNumeric(parseInt(item.leftWin)) ? methods.ordinal(item.leftWin) : null;
							rightWinStatus = item.rightWin === "W" ? "WIN" : item.rightWin === "R" ? "RU" :  $.isNumeric(parseInt(item.rightWin)) ? methods.ordinal(item.rightWin) : null;
							leftWinClass = item.leftWin === 'W' ? 'table__driver--winner' : '';
							rightWinClass = item.rightWin === 'W' ? 'table__driver--winner' : '';
						}

						// Multi-lane Races use numbers instead of Left/Right String
						if(isMultiLane){
							leftLane = lanePosition++;
							rightLane = lanePosition++;
						}

						// Represent the Left/Right Win status if Available.
						var leftWin = leftWinStatus !== null ? '<span class="table__bubble">' + leftWinStatus + '</span>' : "";
						var rightWin = rightWinStatus !== null ? '<span class="table__bubble">' + rightWinStatus + '</span>' : "";

						// Create templates for the various race types
						// ALl templates must align, so they should all have 14 columns
						category = item.category.trim().toLowerCase();
						if( "top fuel" === category || "funny car" === category) {

							// Calculate ET (use left/right 1000ft field if it exists, otherwise pull from 1320ft)
							leftET = (item.left1000ft ? item.left1000ft : item.left1320ft);
							rightET = (item.right1000ft ? item.right1000ft : item.right1320ft);

							// Set Race Details
							titleArea = `
								<th>Lane</th>
								<th colspan="5">Driver</th>
								<th>Car #</th>
								<th>RT</th>
								<th>60 FT</th>
								<th>330 FT</th>
								<th>660 FT</th>
								<th>660 MPH</th>
								<th>ET</th>
								<th>MPH</th>
								<th>MOV</th>
								<th>First</th>
							`;

							rowHeader = `
								// GLOBAL DETAILS
								${spacer}
								<tr class="table__row-heading ${isLast}">
									<td rowspan="${rowSpanSize}" class="table__timeline">
										<time class="table__time">
											${methods.monthDayRaw(item.RaceTime)}<br/>
											${methods.timeFormatRaw(item.RaceTime)}
										</time>
										<span class="table__timeline-icon"></span>
									</td>
									<td rowspan="${rowSpanSize}">
										<div class="table__label">
											<span>${item.category}</span>
										</div>
									</td>
									<th>RND</th>
									${titleArea}
								</tr>`;

							extra = `<tr class="table__row-driver ${item.highlight}"><td rowspan="${rowSpanNoHeaderSize}">${item.rnd}</td></tr>`;

							// Add Each Race to the mark-up variable
							rowBody += `
								// LEFT DRIVER STATS
								<tr class="table__row-driver ${item.highlight}">
									<td>${leftLane}</td>
									<td colspan="5" class="table__driver ${leftWinClass}">${item.driverLeftUrl}${leftWin}</td>
									<td>${item.leftCarNumber}</td>
									<td>${item.leftRT}</td>
									<td>${item.left60ft}</td>
									<td>${item.left330ft}</td>
									<td>${item.left660ft}</td>
									<td>${item.left660mph}</td>
									<td>${leftET}</td>
									<td>${(item.left1000mph) ? item.left1000mph : item.left1320mph}</td>
									<td>${methods.calculateMov(leftWin, item.leftMOV)}</td>
									<td>${item.leftFirst}</td>
								</tr>

								// RIGHT DRIVER STATS
								<tr class="table__row-driver ${item.highlight}">
									<td>${rightLane}</td>
									<td colspan="5" class="table__driver ${rightWinClass}">${item.driverRightUrl}${rightWin}</td>
									<td>${item.rightCarNumber}</td>
									<td>${item.rightRT}</td>
									<td>${item.right60ft}</td>
									<td>${item.right330ft}</td>
									<td>${item.right660ft}</td>
									<td>${item.right660mph}</td>
									<td>${rightET}</td>
									<td>${(item.right1000mph) ? item.right1000mph : item.right1320mph}</td>
									<td>${methods.calculateMov(rightWin, item.rightMOV)}</td>
									<td>${item.rightFirst}</td>
								</tr>
							`;
						} else {

							// Calculate ET (use left/right 1000ft field if it exists, otherwise pull from 1320ft)
							leftET = (item.left1320ft ? item.left1320ft : item.left1000ft);
							rightET = (item.right1320ft ? item.right1320ft : item.right1000ft);

							// Set Race Details
							titleArea = `
								<th>Lane</th>
								<th>Driver</th>
								<th>Car No.</th>
								<th>Class</th>
								<th>Dial In</th>
								<th>RT</th>
								<th>60 FT</th>
								<th>330 FT</th>
								<th>660 FT</th>
								<th>660 MPH</th>
								<th>1000 FT</th>
								<th>ET</th>
								<th>MPH</th>
								<th>Ov/Un</th>
								<th>MOV</th>
								<th>First</th>
							`;

							rowHeader = `
							// GLOBAL DETAILS
							${spacer}
							<tr class="table__row-heading ${isLast}">
								<td rowspan="${rowSpanSize}" class="table__timeline">
									<time class="table__time">
										${methods.monthDayRaw(item.RaceTime)}<br/>
										${methods.timeFormatRaw(item.RaceTime)}
									</time>
									<span class="table__timeline-icon"></span>
								</td>
								<td rowspan="${rowSpanSize}">
									<div class="table__label">
										<span>${item.category}</span>
									</div>
								</td>
								<th>RND</th>
								${titleArea}
							</tr>`;

							extra = `<tr class="table__row-driver ${item.highlight}"><td rowspan="${rowSpanNoHeaderSize}">${item.rnd}</td></tr>`;

							// Add Each Race to the mark-up variable
							rowBody += `
								// LEFT DRIVER STATS
								<tr class="table__row-driver ${item.highlight}">
									<td>${leftLane}</td>
									<td class="table__driver ${leftWinClass}">${item.driverLeftUrl}${leftWin}</td>
									<td>${item.leftCarNumber}</td>
									<td>${item.leftClassIndex}</td>
									<td>${item.leftDialIn}</td>
									<td>${item.leftRT}</td>
									<td>${item.left60ft}</td>
									<td>${item.left330ft}</td>
									<td>${item.left660ft}</td>
									<td>${item.left660mph}</td>
									<td>${item.left1000ft}</td>
									<td>${leftET}</td>
									<td>${(item.left1320mph)? item.left1320mph : item.left1000mph}</td>
									<td>${methods.calculateOvUn(leftET, item.leftDialIn)}</td>
									<td>${methods.calculateMov(leftWin, item.leftMOV)}</td>
									<td>${item.leftFirst}</td>
								</tr>
								// RIGHT DRIVER STATS
								<tr class="table__row-driver ${item.highlight}">
									<td>${rightLane}</td>
									<td class="table__driver ${rightWinClass}">${item.driverRightUrl}${rightWin}</td>
									<td>${item.rightCarNumber}</td>
									<td>${item.rightClassIndex}</td>
									<td>${item.rightDialIn}</td>
									<td>${item.rightRT}</td>
									<td>${item.right60ft}</td>
									<td>${item.right330ft}</td>
									<td>${item.right660ft}</td>
									<td>${item.right660mph}</td>
									<td>${item.right1000ft}</td>
									<td>${rightET}</td>
									<td>${(item.right1320mph)? item.right1320mph : item.right1000mph}</td>
									<td>${methods.calculateOvUn(rightET, item.rightDialIn)}</td>
									<td>${methods.calculateMov(rightWin, item.rightMOV)}</td>
									<td>${item.rightFirst}</td>
								</tr>
							`;
						}
					});
					raceMarkUp += (rowHeader + extra +  rowBody);
				});
			}
			// Render Content.
			$context.html(raceMarkUp).removeClass(settings.loadingclass);
			setTimeout(function () {
				$('.' + settings.updateClass).removeClass(settings.updateClass);
				reRendering = false;
			}, 1000);
		}

		methods.renderMobile = function($context, transition) {

			// If this is the first load, get the caption mark.
			raceMarkUp = originalMarkUp;

			// Alternative Layouts
			var altLayout = ['top fuel', 'funny car'];

			// Check category of each item
			var category;

			// IF: there is an error loading the data.
			if (liveEventsCollection == "error" || liveEventsCollection.length < 1) {
				$context.addClass(settings.errorClass);
				raceMarkUp += `<tr class="table__row-spacer"><td colspan="16">${settings.errortext}</td></tr>`;

			// ELSE: - render items
			} else {

				$context.removeClass(settings.errorClass);
				liveEventsCollection.forEach(function (chunk, chunkIndex) {

					var rowHeader = '';
					var rowBody = '';
					var extra = '';
					var lanePosition = 1;
					var chunkSize = chunk.length;
					var isMultiLane = chunkSize > 1;
					var progressExtendedClass = '';

					// Spaces out each race
					var spacer = chunkIndex === 0 ? '' : '<tr class="table__row-spacer"><td colspan="14"></td></tr>';
					var isLast = ((chunkIndex + 1) == liveEventsCollection.length ? "last-row" : "");

					chunk.forEach(function (item, index, array) {

						// 2 (header grp + round) + Size of the Group * 2 (2 per group) to get total rowspaw
						var rowSpanSize = 2 + ((chunk.length * 2));
						var rowSpanNoHeaderSize = rowSpanSize - 1;

						// Left/Right Lane Default Text
						var leftLane = "Left";
						var rightLane = "Right";

						// Result Ranks
						var leftWinStatus = null;
						var rightWinStatus = null;
						var leftWinClass = "";
						var rightWinClass = "";

						var leftStatusClass = "";
						var rightStatusClass="";

						// Defaults
						leftET = null;
						rightET = null;

						// If round name starts w/ q (Qualifying round), ignore (per spec).
						// Set the ranking of the drivers.
						if ('q' !== item.rnd.charAt(0).toLowerCase() ) {
							leftWinStatus = item.leftWin === "W" ? "W" : item.leftWin === "R" ? "R" :  $.isNumeric(parseInt(item.leftWin)) ? item.leftWin : null;
							rightWinStatus = item.rightWin === "W" ? "W" : item.rightWin === "R" ? "R" :  $.isNumeric(parseInt(item.rightWin)) ? item.rightWin : null;
							leftWinClass = item.leftWin === 'W' ? 'table__driver--winner' : '';
							rightWinClass = item.rightWin === 'W' ? 'table__driver--winner' : '';
						}

						if(leftWinStatus || item.leftFlags) {
							leftStatusClass = "table__has-status"
						}

						if(rightWinStatus || item.rightFlags) {
							rightStatusClass = "table__has-status"
						}

						// Multi-lane Races use numbers instead of Left/Right String
						if(isMultiLane){
							leftLane = lanePosition++;
							rightLane = lanePosition++;
							progressExtendedClass = 'timeline-extended'
						}

						// Represent the Left/Right Win status if Available.
						var leftWin = leftWinStatus !== null ? '<span class="table__bubble">' + leftWinStatus + '</span>' : "";
						var rightWin = rightWinStatus !== null ? '<span class="table__bubble">' + rightWinStatus + '</span>' : "";

						category = item.category.trim().toLowerCase();

						if( "top fuel" != category || "funny car"!= category) {
							leftET = (item.left1320ft ? item.left1320ft : item.left1000ft);
							rightET = (item.right1320ft ? item.right1320ft : item.right1000ft);
						}
						else {
							leftET = (item.left1000ft ? item.left1000ft : item.left1320ft);
							rightET = (item.right1000ft ? item.right1000ft : item.right1320ft);
						}

						if(index == 0) {
							rowHeader += `
							<tr class="${isLast}">
								<td colspan="3" class="table__timeline">
									<time class="table__time">
										${methods.monthDayRaw(item.RaceTime)} ${methods.timeFormatRaw(item.RaceTime)}
									</time>
									<span class="table__timeline-icon ${progressExtendedClass}"></span>
								</td>
							</tr>
							<tr class="table__class ${item.highlight}">
								<th>category</th>
								<td colspan="2">${item.category}</td>
							</tr>
							<tr class="table__round ${item.highlight}">
								<th>Round</th>
								<td colspan="2">${item.rnd}</td>
							</tr>
							`;
						}

						rowBody += `
							<tr class="${item.highlight}">
								<th>Lane</th>
								<td class="table__lane">${leftLane}</td>
								<td class="table__lane">${rightLane}</td>
							</tr>
							<tr class="table__row-driver ${item.highlight}">
								<th>Driver</th>
								<td class="table__driver ${leftWinClass} ${leftStatusClass}">
									<span class="table__driver-text">${item.driverLeftUrl}</span> ${leftWin}
								</td>
								<td class="table__driver ${rightWinClass} ${rightStatusClass}">
									<span class="table__driver-text">${item.driverRightUrl}</span> ${rightWin}
								</td>
							</tr>
							<tr>
								<th>Car No.</th>
								<td>${item.leftCarNumber}</td>
								<td>${item.rightCarNumber}</td>
							</tr>
						`;

						if(altLayout.indexOf(category) == -1) {
							rowBody += `
							<tr class="${item.highlight}">
								<th>Class</th>
								<td>${item.leftClassIndex}</td>
								<td>${item.rightClassIndex}</td>
							</tr>
							<tr class="${item.highlight}">
								<th>Dial In</th>
								<td>${item.leftDialIn}</td>
								<td>${item.rightDialIn}</td>
							</tr>
							`;
						}

						rowBody += `
							<tr class="${item.highlight}">
								<th>RT</th>
								<td>${item.leftRT}</td>
								<td>${item.rightRT}</td>
							</tr>
							<tr class="${item.highlight}">
								<th>60FT</th>
								<td>${item.left60ft}</td>
								<td>${item.right60ft}</td>
							</tr>
							<tr class="${item.highlight}">
								<th>330FT</th>
								<td>${item.left330ft}</td>
								<td>${item.right330ft}</td>
							</tr>
							<tr class="${item.highlight}">
								<th>660FT</th>
								<td>${item.left660ft}</td>
								<td>${item.right660ft}</td>
							</tr>
							<tr class="${item.highlight}">
								<th>660 MPH</th>
								<td>${item.left660mph}</td>
								<td>${item.right660mph}</td>
							</tr>
						`;

						if(altLayout.indexOf(category) == -1) {
							rowBody += `
							<tr class="${item.highlight}">
								<th>1000 FT</th>
								<td>${item.left1000ft}</td>
								<td>${item.right1000ft}</td>
							</tr>
							`;
						}
						rowBody += `
							<tr class="${item.highlight}">
								<th>ET</th>
								<td>${leftET}</td>
								<td>${rightET}</td>
							</tr>
							<tr class="${item.highlight}">
								<th>MPH</th>
								<td>${(item.left1320mph)? item.left1320mph : item.left1000mph}</td>
								<td>${(item.right1320mph)? item.right1320mph : item.right1000mph}</td>
							</tr>
							<tr class="${item.highlight}">
								<th>MOV</th>
								<td>${methods.calculateMov(leftWin, item.leftMOV)}</td>
								<td>${methods.calculateMov(rightWin, item.rightMOV)}</td>
						    </tr>
							<tr class="${item.highlight}">
								<th>First</th>
								<td>${item.leftFirst}</td>
								<td>${item.rightFirst}</td>
						    </tr>

						`;

						if(altLayout.indexOf(category) == -1) {
							rowBody += `
							<tr class="${item.highlight}">
								<th>Ov/Un</th>
								<td>${methods.calculateOvUn(leftET, item.leftDialIn)}</td>
								<td>${methods.calculateOvUn(rightET, item.rightDialIn)}</td>
							</tr>
							`;
						}

						if(index == chunk.length - 1) {
							rowBody += ''
						}
					});

					raceMarkUp += (rowHeader +  rowBody);
				});
			}

			$context.html(raceMarkUp).removeClass(settings.loadingclass);
			setTimeout(function () {
				$('.' + settings.updateClass).removeClass(settings.updateClass);
				reRendering = false;
			}, 1000);
		}

		methods.monthDayRaw = function(d) {
			var fixedDate = methods.fixDate(d, false);
			var dateParts = fixedDate.split('-');
			var dayTimeParts = dateParts[2].split('T');
			var month = parseInt(dateParts[1], 10);
			var day = dayTimeParts[0];
			var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
			var monthDay = months[(month-1)] + ' ' + day;
			return monthDay;
		}

		methods.timeFormatRaw = function(d) {
			var fixedDate = methods.fixDate(d, false);
			var dateParts = fixedDate.split('-');
			var dayTimeParts = dateParts[2].split('T');
			var month = parseInt(dateParts[1], 10);
			var day = dayTimeParts[0];
			var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
			var monthDay = months[(month-1)] + ' ' + day;
			var timeFormat = dayTimeParts[1];
			return timeFormat;
		}

		methods.calculateOvUn = function (ET, DialIn) {
			// If either values are empty, return empty string
			if( !ET || !DialIn ) {
				return '--';
			}

			// else calculate OvUn, rounding to 3 decimals
			var _val = (ET - DialIn).toFixed(3);
			return _val;
		}

		methods.calculateMov = function (Win, Mov) {
			// If either values are empty, return empty string
			if( (!Win || Win == '' ) || (!Mov || Mov == '') ) {
				return '--';
			}

			var _val = parseFloat(Mov);

			if( 0 > _val ){
				return '--';
			}

			return _val;
		}

		methods.fixDate = function (d, dateReturn = true) {
            var fixedDate = d;
			if (!/-/.test(d) && !/:/.test(d)) {
				for (var i = 0; i < 17; i++) {
					if (i == 4 || i == 7) {
						var fixedDate = fixedDate.slice(0, i) + "-" + fixedDate.slice(i);
					} else if (i == 13 || i == 16) {
						var fixedDate = fixedDate.slice(0, i) + ":" + fixedDate.slice(i);
					}
				}
			}
			if (dateReturn) {
				return new Date(fixedDate);
			} else {
				return fixedDate;
			}

		}

		methods.compareRaceTime = function (timeA,timeB) {
			if (timeA[0].RaceTime < timeB[0].RaceTime)
				return 1;
			if (timeA[0].RaceTime > timeB[0].RaceTime)
				return -1;
			return 0;
		}

		methods.formatTwoDigits = function(n) {
			var number = n < 10 ? ('0' + n) : n;
			return number;
		}

		methods.timeFormat = function(d) {
			var dateObj = methods.fixDate(d);
			var hours = methods.formatTwoDigits(dateObj.getHours());
			var minutes = methods.formatTwoDigits(dateObj.getMinutes());
			var seconds = methods.formatTwoDigits(dateObj.getSeconds());
			return hours + ":" + minutes + ":" + seconds;
		}

		methods.dayOfWeek = function(n) {
			var dateObj = methods.fixDate(n);
			var dayIndex = dateObj.getDay();
			var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
			return days[dayIndex];
		}

		methods.compareUpdateDate = function (dateA,dateB) {
				var date1 = new Date(dateA[0].UpdatedDate);
				var date2 = new Date(dateB[0].UpdatedDate);

				if(dateA.length > 1) {
					var date1 = new Date(dateA[dateA.length-1].UpdatedDate);
				}
				if(dateB.length > 1) {
					var date2 = new Date(dateB[dateB.length-1].UpdatedDate);
				}
				// return date1-date2;

				if (date1 < date2)
					return -1;
				if (date1 > date2)
					return 1;
				return 0;
		}

		methods.autoRefresh = function($context) {
			methods.loadData($context);
			setInterval(function(){
				methods.loadData($context);
			}, settings.refreshinterval);
		}

		methods.bindEvents = function($context) {
			var resizeTimer;
			settings.$window.on('resize orientationchange', function() {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function() {

					// Checking Class and Window Size Prevents Re-Rendering after Resize/OrientationChange
					if(settings.$window[0].innerWidth > settings.mobileBreakpoint && $context.hasClass('loaded--desktop') == false) {
						$context.html('').addClass(settings.loadingclass + ' loaded--desktop').removeClass('loaded--mobile');
						reRendering = true;

						setTimeout(function () {
							methods.render($context);
						}, 500)

					// Checking Class and Window Size Prevents Re-Rendering after Resize/OrientationChange
					} else if(settings.$window[0].innerWidth <= settings.mobileBreakpoint && $context.hasClass('loaded--mobile') == false) {
						$context.html('').addClass(settings.loadingclass + ' loaded--mobile').removeClass('loaded--desktop');
						reRendering = true;

						setTimeout(function () {
							methods.renderMobile($context);
						}, 500);
					}
				}, 50);
			});
		}

		// On load function
		methods.initContext = function($context, settings) {
			// Get original mark-up of the table (Caption).
			originalMarkUp = $context.html();
			methods.setCurrentSettings($context, settings);
			methods.bindEvents($context);
		}

		// Determine the Digit and associated ordinal designation.
		methods.ordinal = function(input) {
			var s=["th","st","nd","rd"],
			v=input%100;
			return input+(s[(v-20)%10]||s[v]||s[0]);
		}

		// Run once methods when jquery plugin is called.
		methods.initContext($(this), settings);
	};
}(jQuery,Drupal, drupalSettings));
